import { Pipe, PipeTransform } from '@angular/core';
import { ConversationNormalizedMessageStatus } from 'common/store/genesys-cloud/conversations/messages/models/message-data.model';

@Pipe({
  name: 'appChatMessageStatusIconClass'
})
export class ChatMessageStatusIconClassPipe implements PipeTransform {
  transform(messageStatus: ConversationNormalizedMessageStatus): string {
    switch (messageStatus) {
      case 'Sent':
        return 'fa fa-check';
      case 'Published':
      case 'Delivered':
        return 'fa fa-check-circle-o';
      case 'Read':
        return 'fa fa-check-circle';
      case 'Failed':
        return 'fa fa-exclamation-triangle';
      case 'Removed':
        return 'fa fa-times-circle-o';
      default:
        return '';
    }
  }
}
